import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import CustomTextField from '../../CustomizedComponents/CustomTextField';
import { format } from 'date-fns';
import Button from '@material-ui/core/Button';
import { FormattedMessage } from 'react-intl';

const DatePickerWrapper = styled.div`
  padding: 15px;
  display: flex;
  flex-direction: column;

  .datepicker {
    width: 100%;
  }
`;

export const DataTableColumnDatePicker = ({ dateFrom, dateTo, setDateFrom, setDateTo, onClose, currentDateFull, setCurrentFilter = () => {} }) => {
  const dateFromTitle = 'app.dateFrom';
  const dateToTitle = 'app.dateTo';

  const onFilterChange = () => {
    setCurrentFilter([dateFrom, dateTo]);
  };

  const handleDateChange = (changedDateValue, changeDate = () => {}) => {
    if (changedDateValue) {
      changeDate(changedDateValue);
    } else {
      changeDate(currentDateFull);
    }
  };

  return (
    <>
      <DatePickerWrapper>
        <CustomTextField
          id="dateFrom"
          name={'from'}
          className={'datepicker'}
          onChange={(event) => {
            event.stopPropagation();
            handleDateChange(event.target.value, setDateFrom);
          }}
          title={dateFromTitle}
          value={format(new Date(dateFrom), 'yyyy-MM-dd')}
          variant="outlined"
          type="date"
        />

        <CustomTextField
          id="dateTo"
          name={'to'}
          className={'datepicker'}
          onChange={(event) => {
            event.stopPropagation();
            handleDateChange(event.target.value, setDateTo);
          }}
          title={dateToTitle}
          value={format(new Date(dateTo), 'yyyy-MM-dd')}
          variant="outlined"
          type="date"
        />

        <Button
          style={{
            marginBottom: 10,
          }}
          variant="contained"
          color={'primary'}
          onClick={() => {
            onClose();
            onFilterChange();
          }}>
          <FormattedMessage id={'app.dataTable.columnFilter.filter'} />
        </Button>

        <Button
          color={'primary'}
          onClick={() => {
            onClose();
            setCurrentFilter([]);
          }}>
          <FormattedMessage id={'app.dataTable.columnFilter.clear'} />
        </Button>
      </DatePickerWrapper>
    </>
  );
};

DataTableColumnDatePicker.propTypes = {
  dateFrom: PropTypes.any,
  currentDateFull: PropTypes.any,
  currentFilter: PropTypes.array,
  dateTo: PropTypes.any,
  setDateFrom: PropTypes.func,
  setDateTo: PropTypes.func,
  onClose: PropTypes.func,
  setCurrentFilter: PropTypes.func,
};
